/*
commonview/view-spinnersmall

usage:
this module returnes a dom-element and some controls to display it

import viewSpinner from './view-spinnersmall';
let mySpinner = viewSpinner.create({wrap:myDomElement});
mySpinner.show();

*/
import core from '../../common/lib/core.js';

const classnameHide = 'u-hide';
const classnameShow = 'u-show';
const classnameDim = 'btn--is-loading';
const create = core.create; /* create elements that can be inserted into the dom */

function createSpinner() {
	return create({
		type: 'div',
		class: 'spinner u-hide'
		/* set the z-index correctly with _z-index.scss. A value below 9 hides it due to the z-index of '.overlay' */
	});
}

function showSpinner(spinElm, siblingElm) {
	core.removeClass(spinElm, classnameHide);
	core.addClass(spinElm, classnameShow);
	core.addClass(siblingElm, classnameDim);
}

function hideSpinner(spinElm, siblingElm) {
	core.removeClass(spinElm, classnameShow);
	core.addClass(spinElm, classnameHide);
	core.removeClass(siblingElm, classnameDim);
}

export default {
	create(p) {
		let elements = {};
		elements.wrap = createSpinner();
		elements.sibling = core.getElementIfValid(p, 'sibling', 'view-spinnersmall:57');
		return {
			wrap: elements.wrap,
			show() {
				showSpinner(elements.wrap, elements.sibling);
			},
			hide() {
				hideSpinner(elements.wrap, elements.sibling);
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				hideSpinner(elements.wrap, elements.sibling);
				core.deleteElementsInObjectExcept(elements, ['wrap'], 'view-spinnersmall:46');
				elements = null;
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/commonview/lib/view-spinnersmall.js